var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3.53101L19.1119 9.19117C19.3602 9.53294 19.7103 9.78732 20.1121 9.91783L26.7658 12.0794L22.6533 17.7391C22.405 18.0809 22.2713 18.4925 22.2713 18.9149L22.2717 25.911L15.6181 23.7487C15.2164 23.6181 14.7836 23.6181 14.3819 23.7487L7.72831 25.911L7.72868 18.9149C7.7287 18.4925 7.59497 18.0809 7.34665 17.7391L3.23417 12.0794L9.88794 9.91783C10.2897 9.78732 10.6398 9.53294 10.8881 9.19117L15 3.53101Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0489c6534890a72e8c78cd04ca7667e2.svg";
export { ForwardRef as ReactComponent };